"use strict";

var _Object$defineProperty = require("@babel/runtime-corejs3/core-js-stable/object/define-property");
var _interopRequireDefault = require("@babel/runtime-corejs3/helpers/interopRequireDefault");
_Object$defineProperty(exports, "__esModule", {
  value: true
});
exports.getBadgeFields = getBadgeFields;
exports.getSummaryData = getSummaryData;
var _map = _interopRequireDefault(require("@babel/runtime-corejs3/core-js-stable/instance/map"));
var _globals = require("./constants/globals");
/**
 * I adapted this from pmc/api/helpers/providers.py badge_fields method.
 * Gets either the config badge_data or defaults and returns an array of the field strings
 * @param {object} config The config object to pull badges from.
 * @return {string[]} An array of badge strings.
 */
function getBadgeFields(config) {
  const badgeConfigs = config.provider.badge_data || _globals.DEFAULTS.BADGE_FIELDS;
  return (0, _map.default)(badgeConfigs).call(badgeConfigs, badgeConfig => badgeConfig.field);
}

/**
 * I stole this from pmc/api/helpers/providers.py summary_configs method.
 * Gets either the config summary_data or the default
 * @param {object} config The config object to pull summary data from.
 * @return {object[]} An array of summary data objects.
 */
function getSummaryData(config) {
  return config.search_results_page.summary_data || _globals.DEFAULTS.SUMMARY_DATA;
}